import styled from 'styled-components';

const Branding = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  position: relative;
`;

const ImagePreviewWrapper = styled.div`
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(7, 1fr);
  margin-top: 16px;
  position: relative;
`;

const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

const TitleWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-bottom: 8px;
  position: relative;
`;

const BrandingCard = styled.div`
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  max-width: 800px;
  padding: 16px;
`;

const DigitalWrapperCard = styled.div`
  max-width: 800px;
`;

const DigitalWrapperContainer = styled.div`
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  display: flex;
  padding: 16px;
`;

const DigitalWrapperPreview = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  width: 100%;
`;

export {
  Branding,
  BrandingCard,
  DigitalWrapperCard,
  DigitalWrapperContainer,
  DigitalWrapperPreview,
  ImagePreviewWrapper,
  LogoWrapper,
  TitleWrapper
};
